module.exports = __webpack_public_path__ + "static/media/cover-product-2.7ea8d7a2.jpg";